import API from '../interceptors/Api';
import { LINK_QUEUED_STATUS } from '../assets/constants/Link';
// MOCK SECTION — remove once openbanking-core 4.0.81 ships the real sync-history/sync-summary endpoints.
import { mockGetLinkSyncHistory, mockGetLinkSyncSummary } from './Links.syncMock';

const USE_SYNC_MOCK = false;

export const getLinks = (params) => API.get('/links', {
  params,
});

export const enableLinkStatus = (id, status) => API.patch(`/links/${id}/status/${status}`);

export const refreshLink = (id, params: Record<string, any> = {}) => {
  const {
    dateTo,
    dateFrom,
    ...rest
  } = params;
  return API.post(`/links/${id}`, rest, {
    params: {
      dateFrom,
      dateTo,
    },
  });
};

export const createLink = (data) => API.post('/links', data);

export const updateLink = (id, data) => API.put(`/links/${id}`, data);

export const generateManualPreLogin = (id, data?) => API.put(`/links/${id}/manual-pre-login`, data);

export const continueLinkCreation = ({
  linkId,
  authenticationStepId,
  ...data
}) => API.post(`/links/${linkId}/steps/${authenticationStepId}`, data);

export const getLinkDetail = (id, params: Record<string, any> = {}) => API.get(`/links/${id}`, { params });

export const deleteLink = (id) => API.delete(`/links/${id}`);

export const getLinksProcessing = () => API.get('/links/processing');

export const getAllLinks = (params: Record<string, any> = {}, config: Record<string, any> = {}) => API.get('/links', {
  ...config,
  params: {
    page: 0,
    size: 500,
    showRelations: false,
    ...params,
  },
});

export const getAllLinksWithRelations = () => API.get('/links', {
  params: {
    page: 0,
    size: 500,
    showRelations: true,
  },
});

export const checkLinkQueuedStatus = async (linkId, retries = 60) => {
  const link = await API.get(`/links/${linkId}/async-status`);
  const queueEndedStatus = [LINK_QUEUED_STATUS.READY, LINK_QUEUED_STATUS.FAILED];

  if (queueEndedStatus.includes(link?.stepStatus) || retries === 0) {
    return {
      link,
      retries,
    };
  }

  await new Promise((r) => setTimeout(r, 3500));
  return checkLinkQueuedStatus(linkId, retries - 1);
};

export const getInfoCount = () => API.get('/links/info/count');

export const getLinkSyncHistory = (linkId, { day }: Record<string, any> = {}) => {
  if (USE_SYNC_MOCK) return mockGetLinkSyncHistory(linkId);
  return API.get(`/links/${linkId}/sync-history`, {
    params: day ? { day } : {},
  });
};

export const getLinkSyncSummary = (ids) => {
  if (USE_SYNC_MOCK) return mockGetLinkSyncSummary(Array.isArray(ids) ? ids : [ids]);
  return API.get('/links/sync-summary', {
    params: { ids: Array.isArray(ids) ? ids.join(',') : ids },
  });
};

export const getLinkSubLinksSummary = (ids) => API.get('/links/sub-links/summary', {
  params: { ids: Array.isArray(ids) ? ids.join(',') : ids },
});

export const linkSyncAssets = (linkId, data: Record<string, any> = {}) => API.post(`/links/sync/assets/${linkId}`, data);

export const linkSyncInfo = (linkId, config) => API.get(`/accounts/sync-status?linkId=${linkId}`, config);

export const getLinksFailedSyncs = () => API.get('/links/failed-syncs');

export const linksFailedSyncs = () => API.post('/links/failed-syncs');

export const getLinkMetadata = (id) => API.get(`/links/${id}/metadata`);

export const regenerateTrxSummary = (id, data) => API.post(`/links/${id}/transaction-summary-event`, data);

export const categorizeTrx = (id, data) => API.post(`/links/${id}/categorization-event`, data);

export const getCategorizationRequests = (id, params: Record<string, any> = {}) => API.get(`/links/${id}/categorization-requests`, { params });

export const getActiveCategorizationRequests = (ids) => API.get('/links/categorization-requests/active', {
  params: { linkIds: Array.isArray(ids) ? ids.join(',') : ids },
});
